import { observer } from 'mobx-react';
import { SinglePropertyLoanEconomicsForm } from '../loanEconomics/singlePropertyLoanEconomicsForm';

export const SinglePropertyLoanEconomicsStep = observer(({ store, loanEconomicsStore, substep, onNext }) => {
  return <SinglePropertyLoanEconomicsForm onNext={onNext} store={store} loanEconomicsStore={loanEconomicsStore} substep={substep} />
});